// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Update, Delete.
// MODIFIED DATE : 14-08-2025

const GroupAccountActionTypes = {
	/*** ADD GROUP ACCOUNT DETAILS START ***/
	ADD_GROUP_ACCOUNT_DETAILS_START: 'add_group_account_details_start',
	ADD_GROUP_ACCOUNT_DETAILS_SUCCESS: 'add_group_account_details_success',
	ADD_GROUP_ACCOUNT_DETAILS_FAILURE: 'add_group_account_details_failure',
	ADD_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET: 'add_group_account_details_response_reset',
	ADD_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'add_group_account_details_response_changed',
	/*** ADD GROUP ACCOUNT DETAILS END ***/

	/*** UPDATE GROUP ACCOUNT DETAILS START ***/
	UPDATE_GROUP_ACCOUNT_DETAILS_START: 'update_group_account_details_start',
	UPDATE_GROUP_ACCOUNT_DETAILS_SUCCESS: 'update_group_account_details_success',
	UPDATE_GROUP_ACCOUNT_DETAILS_FAILURE: 'update_group_account_details_failure',
	UPDATE_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET: 'update_group_account_details_response_reset',
	UPDATE_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'update_group_account_details_response_changed',
	/*** UPDATE GROUP ACCOUNT DETAILS END ***/

	/*** GET GROUP ACCOUNT LIST START ***/
	GET_GROUP_ACCOUNT_LIST_START: 'get_group_account_list_start',
	GET_GROUP_ACCOUNT_LIST_SUCCESS: 'get_group_account_list_success',
	GET_GROUP_ACCOUNT_LIST_FAILURE: 'get_group_account_list_failure',
	GET_GROUP_ACCOUNT_LIST_RESPONSE_RESET: 'get_group_account_list_response_reset',
	GET_GROUP_ACCOUNT_LIST_RESPONSE_CHANGED: 'get_group_account_list_response_changed',
	/*** GET GROUP ACCOUNT LIST END ***/

	/*** GET PRIMARY ACCOUNT LIST START ***/
	GET_PRIMARY_ACCOUNT_LIST_START: 'get_primary_account_list_start',
	GET_PRIMARY_ACCOUNT_LIST_SUCCESS: 'get_primary_account_list_success',
	GET_PRIMARY_ACCOUNT_LIST_FAILURE: 'get_primary_account_list_failure',
	GET_PRIMARY_ACCOUNT_LIST_RESPONSE_RESET: 'get_primary_account_list_response_reset',
	GET_PRIMARY_ACCOUNT_LIST_RESPONSE_CHANGED: 'get_primary_account_list_response_changed',
	/*** GET PRIMARY ACCOUNT LIST END ***/

	/*** FETCH GROUP ACCOUNT DETAILS START ***/
	FETCH_GROUP_ACCOUNT_DETAILS_START: 'fetch_group_account_details_start',
	FETCH_GROUP_ACCOUNT_DETAILS_SUCCESS: 'fetch_group_account_details_success',
	FETCH_GROUP_ACCOUNT_DETAILS_FAILURE: 'fetch_group_account_details_failure',
	FETCH_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET: 'fetch_group_account_details_response_reset',
	FETCH_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'fetch_group_account_details_response_changed',
	/*** FETCH GROUP ACCOUNT DETAILS END ***/

	/*** DELETE GROUP ACCOUNT DETAILS START ***/
	DELETE_GROUP_ACCOUNT_DETAILS_START: 'delete_group_account_details_start',
	DELETE_GROUP_ACCOUNT_DETAILS_SUCCESS: 'delete_group_account_details_success',
	DELETE_GROUP_ACCOUNT_DETAILS_FAILURE: 'delete_group_account_details_failure',
	DELETE_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET: 'delete_group_account_details_response_reset',
	DELETE_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED: 'delete_group_account_details_response_changed',
	/*** DELETE GROUP ACCOUNT DETAILS END ***/

	/*** ALL GROUP ACCOUNT EXPORT START ***/
	ALL_GROUP_ACCOUNT_EXPORT_START: 'all_group_account_export_start',
	ALL_GROUP_ACCOUNT_EXPORT_SUCCESS: 'all_group_account_export_success',
	ALL_GROUP_ACCOUNT_EXPORT_FAILURE: 'all_group_account_export_failure',
	ALL_GROUP_ACCOUNT_EXPORT_RESPONSE_RESET: 'all_group_account_export_response_reset',
	ALL_GROUP_ACCOUNT_EXPORT_RESPONSE_CHANGED: 'all_group_account_export_response_changed',
	/*** ALL GROUP ACCOUNT EXPORT END ***/
};

export default GroupAccountActionTypes;
